"use client";
import Image from "next/image";
import Link from "next/link";
import React from "react";

import { useTranslation } from 'react-i18next';

// datos: lo que arma el server (app/[locale]/sobre-mi/page.jsx) con fichas.json y el
// catalogo: los datos del autor y la lista de libros con link a cada ficha. La pagina
// eran cinco parrafos sin titulo: no decia de donde soy ni que libros escribi, y es la
// que abre un asistente de IA cuando le preguntan quien es el autor.
export default function HomeSobreMi({ datos = null }) {
  const { t } = useTranslation();
  const libros = Array.isArray(datos?.libros) ? datos.libros : [];

  return (
    <div className="container position-relative pt-130 pb-60">
      <div className="row">
        <div className="col-lg-6 order-2 order-md-1 pt-4 pt-md-1">
          <div className="row mb-sm-30">
            <div className="col-md-10">
              <h1 style={{ fontSize: 28, fontWeight: 600, lineHeight: 1.3, letterSpacing: 0, margin: "0 0 20px" }}>
                Brian Callipari
              </h1>
              <p className="text-gray">
                {t('about_me_p_1')}
              </p>
              <p className="text-gray">
                {t('about_me_p_2')}
              </p>
              <p className="text-gray">
                {t('about_me_p_3')}
              </p>
              <p className="text-gray">
                {t('about_me_p_4')}
              </p>
              <p className="text-gray">
                {t('about_me_p_5')}
              </p>
              {datos?.facts ? (
                <p className="text-gray">
                  {datos.facts}
                </p>
              ) : null}
              {libros.length > 0 && datos?.booksTitle ? (
                <>
                  <h2 style={{ fontSize: 20, fontWeight: 600, lineHeight: 1.3, letterSpacing: 0, margin: "30px 0 12px" }}>
                    {datos.booksTitle}
                  </h2>
                  <ul className="text-gray" style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9 }}>
                    {libros.map((libro) => (
                      <li key={libro.slug}>
                        <Link href={libro.href} prefetch={false}>{libro.name}</Link>
                        {libro.preorderNote ? ` · ${libro.preorderNote}` : ""}
                      </li>
                    ))}
                  </ul>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div
          className="col-lg-6 d-flex wow fadeInLeft order-1 order-md-2 pt-3 pt-md-0"
          data-wow-delay="0.55s"
          data-wow-offset={275}
        >
          <div className="tab-content services-content">
            <div
              className="tab-pane services-content-item show fade active align-items-center d-flex"
              id="services-item-1"
              role="tabpanel"
            >
              <Image
                width={945}
                height={1016}
                quality={60}
                className="services-image"
                src="/brian-about-me.webp"
                alt="Brian Callipari"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
